import React from "react";
import S from "./DescriptionEvent.module.scss";
import backgroundForCompany1 from "../../shared/assets/images/backgroundForCompany1.png";
import logistic from "../../shared/assets/images/imgLogistic.png";

interface IProps {
    id: number;
}

export const DescriptionQuestionEvent = ({id}: IProps) => {
    return (
        <div className={S.contentDiv}>
            <div className={S.backgroundForCompany1}>
                {id === 5 ? (
                    <img src={logistic} alt="logistic"/>
                ) : (
                    <img src={backgroundForCompany1} alt="backgroundForCompany1"/>
                )}
            </div>
            {id === 1 ? (
                <div className={S.content}>
                    <div className={S.title}>Для кого</div>
                    <div className={S.mainText}>
                        <span>Отраслевым компаниям</span> — руководителям и специалистам предприятий ГМК, ТЭК,
                        нефтехимии, машиностроения, горнодобычи и авиастроения:
                    </div>
                    <div className={S.paragraphText}>
                        <div className={S.mainText}>• ИТ-директор (CIO), директор по цифровой трансформации (CDO);</div>
                        <div className={S.mainText}>• директор по данным (Chief Data Officer), руководитель
                            ИТ-архитектуры;
                        </div>
                        <div className={S.mainText}>• руководитель направления автоматизации производства (MES/APS);
                        </div>
                        <div className={S.mainText}>• руководитель АСУ ТП, руководитель отдела АСУП;</div>
                        <div className={S.mainText}>• директор по информационной безопасности;</div>
                        <div className={S.mainText}>• технический директор, главный инженер, главный технолог;</div>
                        <div className={S.mainText}>• директор по производству, директор по операционной
                            эффективности;
                        </div>
                        <div className={S.mainText}>• руководитель службы ТОиР, главный механик, главный энергетик;
                        </div>
                        <div className={S.mainText}>• руководитель службы охраны труда и промышленной безопасности.
                        </div>
                    </div>
                    <div className={S.mainText}>
                        Вы получите работающие практики коллег из индустрии — то, что не публикуют в открытом доступе.
                        Закрытый формат и ограниченное количество мест означают: в зале только те, кто действительно
                        решает вопросы цифровизации.
                    </div>
                    <div className={S.mainText}><span>Возможности для промышленных компаний:</span></div>
                    <div className={S.paragraphText}>
                        <div className={S.mainText}>• <span>Работающие практики с цифрами.</span> Кейсы внедрений с
                            измеримым эффектом: 1,8 млрд ₽/год на стане 2000, 4,2 млрд ₽ на предиктивном обслуживании,
                            +1,3 п.п. извлечения золота. То, что не публикуют в открытом доступе, — здесь обсуждают
                            вживую.
                        </div>
                        <div className={S.mainText}>• <span>Решение под вашу задачу.</span> Приезжайте с проблемой —
                            увезёте план: на форуме разбирают, что дало результат, что не сработало и с чего начать
                            внедрение первым делом.
                        </div>
                        <div className={S.mainText}>• <span>Сверка с рынком поставщиков.</span> MES, APS, EAM, СУБД,
                            IIoT-платформы, решения ИИ — увидите предложение рынка в одном месте и зададите вопросы
                            напрямую разработчикам.
                        </div>
                        <div className={S.mainText}>• <span>Опыт смежных отраслей.</span> Ядерная отрасль, золотодобыча,
                            авиа- и машиностроение — что из их практик можно взять на вооружение.
                        </div>
                        <div className={S.mainText}>• <span>Кадры и знания.</span> Как сохранить экспертизу, оцифровать
                            знания и обучить коллектив — отдельная линия программы.
                        </div>
                    </div>
                    <div className={S.mainText}><span>Поставщикам</span> — разработчикам MES-, APS-, EAM-систем,
                        IIoT-платформ, решений ИИ и промышленной робототехники, поставщикам ПО и ИТ-инфраструктуры.
                    </div>
                    <div className={S.mainText}><span>Возможности для поставщиков:</span></div>
                    <div className={S.paragraphText}>
                        <div className={S.mainText}>• <span>Выставочная зона.</span> Покажите продукт в действии —
                            аудитории, которая приехала именно за этим.
                        </div>
                        <div className={S.mainText}>• <span>Доклад с трибуны.</span> Представьте кейс внедрения и
                            закрепите статус эксперта рынка.
                        </div>
                        <div className={S.mainText}>• <span>Прямой диалог.</span> Руководители цифровой трансформации,
                            ИТ-директора, главные инженеры — без случайной публики: формат закрытого мероприятия.
                        </div>
                        <div className={S.mainText}>• <span>Квалифицированные контакты.</span> Участники приезжают с
                            задачами и планами внедрений: за дни форума — контакты, на которые в обычных условиях уходят
                            месяцы.
                        </div>
                        <div className={S.mainText}>• <span>Демо-день ИЦК.</span> Возможность показать решение в контуре
                            отраслевой программы импортозамещения — перед заказчиками, которые тиражируют проверенные
                            продукты.
                        </div>
                    </div>
                </div>
            ) : (
                id === 5 ? (
                    <div className={S.content}>
                        <div className={S.title}>Для кого</div>
                        <div className={S.mainText}>
                            <span>Отраслевым компаниям</span> — руководителям и специалистам предприятий ГМК, ТЭК
                            нефтехимия и машиностроения:
                        </div>
                        <div className={S.paragraphText}>
                            <div className={S.mainText}>• директор по транспорту и логистике, директор по логистике;
                            </div>
                            <div className={S.mainText}>• начальник управления транспорта, начальник транспортного цеха,
                                руководитель автопарка;
                            </div>
                            <div className={S.mainText}>• начальник управления железнодорожного транспорта, руководитель
                                ж/д цеха;
                            </div>
                            <div className={S.mainText}>• руководитель службы эксплуатации и ТОиР, главный механик,
                                главный инженер;
                            </div>
                            <div className={S.mainText}>• технический директор, директор по производству, директор по
                                операционной эффективности;
                            </div>
                            <div className={S.mainText}>• руководитель отдела закупок (запчасти, ТМЦ, топливо, услуги
                                перевозок);
                            </div>
                            <div className={S.mainText}>• ИТ-директор, руководитель цифровой трансформации;
                            </div>
                            <div className={S.mainText}>• руководитель службы охраны труда и промышленной безопасности.
                            </div>
                        </div>
                        <div className={S.mainText}>
                            Вы получите работающие практики коллег из индустрии — то, что не публикуют в открытом
                            доступе. Закрытый формат и ограниченное количество мест означают: в зале только те, кто
                            действительно решает вопросы транспорта и логистики.
                        </div>
                        <div className={S.paragraphText}>
                            <div className={S.mainText}>• <span>Работающие практики коллег.</span> Кейсы внедрений с
                                цифрами экономии: ТОиР и КТГ техники, экономика эксплуатации (запчасти, шины, топливо,
                                ТМЦ), сквозное планирование перевозок. То, что не публикуют в открытом доступе, — здесь
                                обсуждают вживую.
                            </div>
                            <div className={S.mainText}>• <span>Решение под вашу задачу.</span> Приезжайте с проблемой
                                — увезёте план: на форуме разбирают, что дало результат, что не сработало и с чего
                                начать внедрение первым делом.
                            </div>
                            <div className={S.mainText}>• <span>Сверка с рынком поставщиков.</span> TMS-, WMS-,
                                ERP-системы, платформы грузоперевозок, решения ИИ и беспилотных технологий — увидите
                                предложение рынка в одном месте и сможете задать вопросы напрямую разработчикам и
                                производителям.
                            </div>
                            <div className={S.mainText}>• <span>Опыт смежных отраслей.</span> Порт, нефтегаз, ритейл,
                                FMCG — что из их практик можно взять на вооружение в вашем транспортном хозяйстве.
                            </div>
                        </div>
                        <div className={S.mainText}>
                            <span>Поставщикам</span> — разработчикам TMS-, WMS-, ERP-систем, платформ грузоперевозок,
                            решений ИИ и беспилотных технологий, производителям техники, запчастей и сервисных услуг.
                        </div>
                        <div className={S.mainText}>
                            <span>Возможности для поставщиков:</span>
                        </div>
                        <div className={S.paragraphText}>
                            <div className={S.mainText}>• <span>Выставочная зона.</span> Покажите продукт в действии —
                                технику, запчасти, программные решения — аудитории, которая приехала именно за этим.
                            </div>
                            <div className={S.mainText}>• <span>Доклад с трибуны.</span> Представьте кейс внедрения и
                                закрепите статус эксперта рынка.
                            </div>
                            <div
                                className={S.mainText}>• <span>Прямой диалог. Квалифицированные контакты.</span> Руководители
                                транспортных служб, ТОиР и закупок — без случайной публики: формат закрытого
                                мероприятия.
                            </div>
                            <div
                                className={S.mainText}>• <span>Квалифицированные контакты.</span> Участники приезжают с
                                задачами: за три дня — контакты, на которые в обычных условиях уходят месяцы.
                            </div>
                        </div>
                    </div>
                ) : null
            )}
        </div>
    );
};